import { render, staticRenderFns } from "./LiabilityOtherMortgage.vue?vue&type=template&id=6bbd5118"
import script from "./LiabilityOtherMortgage.vue?vue&type=script&lang=js"
export * from "./LiabilityOtherMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports